<template>
  <div class="text-left">
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }"
        ><br />
        <v-btn color="deep-purple accent-4" dark v-bind="attrs" v-on="on">click</v-btn>
      </template>

      <v-card elevation="24" max-width="800" class="mx-auto">
        <!-- <v-system-bar lights-out></v-system-bar> -->
        <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="true"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          height="500"
        >
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0">
                  <div class="slide">
                    <img src="../assets/ang22.png" width="750" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0 ">
                  <div class="slide">
                    <img src="../assets/ang3.png" width="750" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet color="white" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <div class="display-0 ">
                  <div class="slide">
                    <img src="../assets/ang4.png" width="650" />
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <h2>ANGULAR STARTER</h2>
              <br />
              Angular Starter Project is a Software in house of Aware tectnology
              solution for the new employee learn before start the project or
              for copying the component to using with project
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: false,
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
    };
  },
};
</script>
<style scoped>
.slide {
  color: black !important;
}
</style>
